import economicalStatuses from './economicalStatuses';

function economicalStatusColors(status) {
	switch (status) {
	case economicalStatuses.incomplete:
		return 'red';
	case economicalStatuses.notSettled:
		return 'yellow';
	case economicalStatuses.settled:
		return 'green';
	case economicalStatuses.invoiced:
		return 'gray';
	case economicalStatuses.recorded:
		return 'gray';
	case economicalStatuses.cancelled:
		return 'blue';
	default:
		return 'gray';
	}
}

export default economicalStatusColors;
